import React from 'react';
import './PublicStoreLinkButton.css';

function buildPublicStoreUrl(customName) {
  const slug = String(customName ?? '').trim().replace(/^\/+/, '');
  if (!slug) return '';

  let origin = "https://quokka.kg";
    // typeof window !== 'undefined' && window.location?.origin
    //   ? window.location.origin
    //   : '';
  if (origin.startsWith('https://')) {
    origin = origin.slice('https://'.length);
  } else if (origin.startsWith('http://')) {
    origin = origin.slice('http://'.length);
  }
  if (!origin) return `/${slug}`;
  return `${origin}/${slug}`;
}

async function copyToClipboard(text) {
  if (!text) return false;

  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (_) {
    // fall through
  }

  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    textarea.style.top = '0';
    document.body.appendChild(textarea);
    textarea.select();
    textarea.setSelectionRange(0, textarea.value.length);
    const ok = document.execCommand('copy');
    document.body.removeChild(textarea);
    return ok;
  } catch (_) {
    return false;
  }
}

export default function PublicStoreLinkButton({ customName, loading }) {
  const [copied, setCopied] = React.useState(false);
  const copiedTimeoutRef = React.useRef(null);

  const publicStoreUrl = React.useMemo(
    () => buildPublicStoreUrl(customName),
    [customName]
  );

  const onCopy = React.useCallback(async () => {
    const ok = await copyToClipboard(publicStoreUrl);
    if (!ok) return;
    setCopied(true);
    if (copiedTimeoutRef.current) window.clearTimeout(copiedTimeoutRef.current);
    copiedTimeoutRef.current = window.setTimeout(() => {
      copiedTimeoutRef.current = null;
      setCopied(false);
    }, 2000);
  }, [publicStoreUrl]);

  React.useEffect(() => {
    return () => {
      if (copiedTimeoutRef.current) window.clearTimeout(copiedTimeoutRef.current);
    };
  }, []);

  if (loading) {
    return (
      <div
        className="main-page-publicLinkSkeleton main-page-skeleton main-page-skeleton--text"
        aria-hidden="true"
      />
    );
  }

  if (!publicStoreUrl) return null;

  return (
    <button
      type="button"
      className={[
        'main-page-publicLinkButton',
        copied ? 'main-page-publicLinkButton--copied' : null,
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={onCopy}
      title="Скопировать ссылку"
    >
      {copied ? 'ссылка скопировано' : `ваш сайт: ${publicStoreUrl}`}
    </button>
  );
}

